import PropTypes from "prop-types"
import React from "react"
import StyledSwatchSquare from "./styled/StyledSwatchSquare"
import StyledTraySwatch from "./styled/StyledTraySwatch"
import { genUniqKey } from "./../../helpers"

const getNameFromPath = path =>
  path
    .split("/")
    .pop()
    .split(".")
    .shift()

const key = genUniqKey()
const Tray = ({ isActive, onClick, tray }) => {
  const handleClick = React.useCallback(() => onClick(tray), [])
  const swatch = React.useMemo(
    () => <StyledTraySwatch tray={`${tray}?${key}`} onClick={handleClick} />,
    []
  )

  return (
    <StyledSwatchSquare
      data-toggle="tooltip"
      title={getNameFromPath(tray)}
      isActive={isActive}
      key={tray}
    >
      {swatch}
    </StyledSwatchSquare>
  )
}

Tray.propTypes = {
  border: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  isActive: PropTypes.string.isRequired,
}
export default React.memo(Tray)
